import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

export default function initialiseTranslations() {
    i18n
        .use(Backend)
        .use(initReactI18next)
        .init({
            interpolation: { 
                escapeValue: false
            },
            lng: 'en',
            fallbackLng: 'en',
            backend: {
                loadPath: '/locales/{{lng}}/{{ns}}.json'
            },
            defaultNS: 'general'
        });
}